<template>
    <div>
        <label for="buscaCid">
            {{ label }}
        </label>
        <autosuggest
            ref="autoBuscaCid"
            id="buscaCid"
            :url="$urlBase + '/cidades/buscaCidades'"
            :default="carregaCidade()"
            @result="selecionaCidade"
        />
    </div>
</template>
<script>
import Autosuggest from '@/shared/components/ui/Autosuggest'
export default {
    props: {  
        label: {
            default: 'Município/UF descarregamento'
        },
        filtro: {
            default: null
        },
        municipio_descarregamento: {
            default: null
        }
    },
    components: {
        Autosuggest
    },
    watch: {
        'filtro.municipio_descarregamento'(valor) {
            if(!valor){
                this.$refs.autoBuscaCid.onClear()
            }
        }
    },
    methods: {
        carregaCidade() {
            if (this.filtro['municipio_descarregamento'] != '') {
                return {
                    codigo: this.filtro.municipio_descarregamento,
                    nome: this.filtro.municipio_descarregamento_nome
                }
            } else {
                return null
            }
        },
        selecionaCidade(value) {
            if (value) {
                this.filtro.municipio_descarregamento = value.codigo
                this.filtro.municipio_descarregamento_nome = value.nome
            } else {
                this.filtro.municipio_descarregamento = ''
                this.filtro.municipio_descarregamento_nome = ''
            }
        },
    }
}
</script>